"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _default = function _default() {
  return (0, _preact.h)("svg", {
    "enable-background": "new 0 0 213.1 213.1",
    viewBox: "0 0 213.1 213.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, (0, _preact.h)("circle", {
    cx: "106.6",
    cy: "106.6",
    fill: "#ffcc4d",
    r: "106.6"
  }), (0, _preact.h)("g", {
    fill: "#231f20"
  }, (0, _preact.h)("path", {
    d: "m153.9 108.5c-7.2 0-13.9-3.9-17.5-10.1-.9-1.5-1.5-3.1-2-4.8-.7-2.7.8-5.4 3.5-6.1s5.4.8 6.1 3.5c.2.8.6 1.7 1 2.4 1.8 3.2 5.2 5.1 8.9 5.1s7.1-2 8.9-5.2c.4-.7.7-1.5 1-2.4.7-2.7 3.4-4.3 6.1-3.6s4.3 3.4 3.6 6.1c-.4 1.6-1.1 3.2-1.9 4.7-3.6 6.4-10.4 10.4-17.7 10.4z"
  }), (0, _preact.h)("path", {
    d: "m59.2 108.5c-7.2 0-13.9-3.9-17.5-10.1-.9-1.5-1.6-3.1-2-4.8-.7-2.7.8-5.4 3.5-6.1s5.4.8 6.1 3.5c.2.8.6 1.7 1 2.4 1.8 3.2 5.2 5.1 8.9 5.1s7.1-2 8.9-5.2c.4-.7.7-1.5 1-2.4.7-2.7 3.4-4.3 6.1-3.6s4.3 3.4 3.6 6.1c-.4 1.6-1.1 3.2-1.9 4.7-3.6 6.4-10.4 10.4-17.7 10.4z"
  }), (0, _preact.h)("path", {
    d: "m140.9 154c-1.3 0-2.6-.5-3.5-1.5-8.4-8.4-19.6-13-31.5-13s-23 4.6-31.5 13c-2 2-5.1 2-7.1 0s-2-5.1 0-7.1c10.3-10.3 24-16 38.5-16s28.2 5.7 38.5 16c2 2 2 5.1 0 7.1-.9 1-2.1 1.5-3.4 1.5z"
  })));
};

exports.default = _default;